import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { If } from 'utils';
import { useAppContext } from 'utils/hooks';
import { ReactComponent as PackageIcon } from 'assets/rr-illustrations/package.svg';
import { ReactComponent as SettingsIcon } from 'assets/ss-icons/zero-state-icons/setting.svg';
import { ReactComponent as NoResultsIcon } from 'assets/ss-icons/zero-state-icons/no-results.svg';

export default function TableZeroState({
  searchQuery = '',
  icon = null,
  className = '',
  children = null
}) {
  const { isSSREnv } = useAppContext();

  return (
    <div className={cn(styles.container, className)}>
      <If test={isSSREnv} otherwise={<PackageIcon />}>
        <If test={!!searchQuery} otherwise={icon || <SettingsIcon />}>
          <NoResultsIcon />
        </If>
      </If>
      <div className={styles.helptext}>
        <If test={!!searchQuery} otherwise={children || 'No record found'}>
          No search results found
        </If>
      </div>
    </div>
  );
}
